import apiFetch from '@wordpress/api-fetch';
import { __ } from "@wordpress/i18n";
import { useState } from 'react';
import PageHeading from '../../components/PageHeading/PageHeading';
import useAdminMenuHighlight from '../../hooks/useAdminMenuHighlight';
import './ContactForm.scss';

const ContactForm = () => {
    useAdminMenuHighlight(); 
    const [subject, setSubject] = useState('')
    const [message, setMessage] = useState('')    

    const [processingSend, setProcessingSend] = useState(false)
    const [processingSendRing, setProcessingSendRing] = useState(false)
    const [processingSendTick, setProcessingSendTick] = useState(false)

    // useEffect(() => {
    //     fetchHistories();
    // }, []);

    const handleForm = async () => {
        if (subject && message) {
            setProcessingSend(true)
            setProcessingSendRing(true)
            try {
                const result = await apiFetch({
                    path: "/ultimate-security/v1/feedback",
                    method: "POST",
                    data: {
                        _wpnonce: ultimate_security_ajax_obj.security,
                        subject: subject,
                        message: message
                    }
                });
                console.log(result)
                if (result.success) {  
                    setSubject("")
                    setMessage("")              
                    setProcessingSend(false)
                    setProcessingSendRing(false)
                }
            } catch (error) {
                console.error("Mail Sending Error:", error);
                setProcessingSend(false)
                setProcessingSendRing(false)
            }
        } else {
            alert('Subject or Message can\'t be Empty')
        }
        
    };

    return (
        <>
            <div className='ultimate-security-form-wrapper'>
                <div className="container-fluid">
                    {/* <div className="form-header pb-lg mb-lg border-bottom">
                        <PageHeading
                            title={__("Give Feedback on your experience using Ultimate Security", 'ultimate-security')}
                            subtitle={__("We are improving our product on a regular momenetum. Your feedback is gonna help us get ahead of the curve and provide a robust security solution for you.", "ultimate-security")}
                        />
                    </div> */}
                    <div className="setting-unit pb-lg mb-lg">
                        <div 
                            className="text-center"
                            style={{ width: '100%', maxWidth: '720px', marginLeft: 'auto', marginRight: 'auto' }}
                        >                            
                            <img 
                                style={{ display: 'inline-block', marginBottom: '30px' }}
                                src={ultimate_security_ajax_obj.imageUrl+'contactformBadge.svg'}
                            />
                            <div className="page-heading-wrap">
                                <h4 
                                    className="section-title pl-heading fw-700 text-text" 
                                    dangerouslySetInnerHTML={{ __html: __("Your Feedback is our product's oxygen", 'ultimate-security') }}
                                />
                                <div 
                                    className="section-intro pl-body text-text"
                                    dangerouslySetInnerHTML={{ __html: __("Thank you for choosing Ultimate Security on your WordPress site. Complete WordPress Protection Without the Complexity.", 'ultimate-security') }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="setting-unit">
                        <div className="form-container">
                            <div className="form-card form-area">
                                <h3 
                                    className="form-title"
                                    dangerouslySetInnerHTML={{ __html: __("Send Us a Message", 'ultimate-security') }}
                                />
                                <div className="form-row">
                                    <label htmlFor="subject">{__("Subject", 'ultimate-security')}</label>
                                    <input 
                                        className="form-input"
                                        type="text" 
                                        id="subject" 
                                        placeholder={__("Set a subject for your feedback", 'ultimate-security')} 
                                        value={subject}
                                        onChange={(e) => setSubject(e.target.value)}
                                    />
                                </div>
                                <div className="form-row">
                                    <label htmlFor="message">{__("Message", 'ultimate-security')}</label>
                                    <textarea 
                                        className="form-input"
                                        id="message" 
                                        rows="6" 
                                        placeholder={__("Being as descriptive as possible is gonna give us a better chance of improving our product for", 'ultimate-security')}
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                    />
                                </div>
                                <div className="form-row">
                                    <div className="d-flex align-items-center gap-2">                                            
                                        <button 
                                            type="button" 
                                            className="button button-primary" 
                                            onClick={handleForm} 
                                            disabled={processingSend}
                                        >
                                            {
                                                processingSend ? __( "Sending...", "ultimate-security" ) : __( "Send Message", "ultimate-security" )
                                            }
                                        </button>
                                        {processingSendRing && <span className="lds-ring"><span></span><span></span><span></span><span></span></span>}
                                        {processingSendTick && <img src={ultimate_security_ajax_obj.imageUrl+'success-tick.svg'}/>}

                                    </div>
                                    <div></div>
                                </div>
                            </div>
                              <div className="setting-unit pb-lg mb-lg">
                       
                    </div>
                      <div className="setting-unit pb-lg mb-lg">
                        <div 
                            className="text-center"
                            style={{ width: '100%', maxWidth: '720px', marginLeft: 'auto', marginRight: 'auto' }}
                        >                            
                            <div className="page-heading-wrap">
                
                                <div 
                                    className="section-intro pl-body text-text"
                                    dangerouslySetInnerHTML={{ __html: __("If you want you can directly mail us at <a href='mailto:support@wpiultiamtesecurity.com'>support@wpultimatesecurity.com.</a>", 'ultimate-security') }}
                                />
                            </div>
                        </div>
                    </div>
                            {/* <div className="row">
                                <div className="col-lg-6 mb-4 mb-lg-0">
                                    <div className="form-card promo-card">
                                        <img 
                                            className="card-image"
                                            src={ultimate_security_ajax_obj.imageUrl+'contactformMail.svg'}
                                        />
                                        <h5 
                                            className="card-title"
                                            dangerouslySetInnerHTML={{ __html: __("Email Support", 'ultimate-security') }}
                                        />
                                        <div 
                                            className="card-intro"
                                            dangerouslySetInnerHTML={{ __html: __("Have a question or need help? Our team is ready to assist you.", 'ultimate-security') }}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-4 mb-lg-0">
                                    <div className="form-card promo-card">
                                        <img 
                                            className="card-image"
                                            src={ultimate_security_ajax_obj.imageUrl+'contactformWordpress.svg'}
                                        />
                                        <h5 
                                            className="card-title"
                                            dangerouslySetInnerHTML={{ __html: __("Email Support", 'ultimate-security') }}
                                        />
                                        <div 
                                            className="card-intro"
                                            dangerouslySetInnerHTML={{ __html: __("Have a question or need help? Our team is ready to assist you.", 'ultimate-security') }}
                                        />
                                    </div>
                                </div>
                            </div> */}
                            
                            <div className="form-notice">
                                <div className="notice-icon">
                                    <img 
                                        src={ultimate_security_ajax_obj.imageUrl+'contactformLock.svg'}
                                    />
                                </div>
                                <div className="notice-content">
                                    <h5 
                                        className="notice-title"
                                        dangerouslySetInnerHTML={{ __html: __("Our Commitment", 'ultimate-security') }}
                                    />
                                    <div 
                                        className="notice-intro"
                                        dangerouslySetInnerHTML={{ __html: __("Ultimate Security takes the hassle out of website protection by delivering strong, silent defense against hackers and vulnerabilities. While it shields your site from threats, you stay free to focus on your business — not your security.", 'ultimate-security') }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ContactForm;